/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContextRef } from './context-ref';
import { MessageHint } from './message-hint';


export interface PostMessageRequest { 
    /**
     * Client-generated id of this send, reused on every retry of it. The chat admits a request id once: a retry after a timeout or a 503 returns the same submission.
     */
    requestId: string;
    /**
     * What to do when the chat is busy: queue it as a follow-up (default), steer the running answer after its current tool round, or reject with 409.
     */
    whenBusy?: PostMessageRequest.WhenBusyEnum;
    /**
     * The user message as typed, including any /slash command.
     */
    message: string;
    /**
     * Entities open (or manually attached) in the app when the message was sent — the composer\'s context chips. Id-only: the agent hydrates them through its get-by-id tools. Echoed back in the message\'s `app.message-meta` entry for its context chips.
     */
    context?: Array<ContextRef>;
    /**
     * The capability an explicit UI action asked for — a composer slash-menu pick, a \"Convert to KPI\" CTA. The server resolves `domain` + `route` against the agent\'s skills and expands that skill exactly as a typed `/command` would; an unknown pair is a 400. A typed slash command in `message` wins over a hint.
     */
    hint?: MessageHint;
}
export namespace PostMessageRequest {
    export type WhenBusyEnum = 'followUp' | 'steer' | 'reject';
    export const WhenBusyEnum = {
        FollowUp: 'followUp' as WhenBusyEnum,
        Steer: 'steer' as WhenBusyEnum,
        Reject: 'reject' as WhenBusyEnum
    };
}


